import { Create, NumberInput, SimpleForm, TextInput } from "react-admin";

export function FriendHostInviteCreate() {
  return (
    <Create redirect="list">
      <SimpleForm defaultValues={{ ttl_days: 30 }}>
        <TextInput source="note" label="Метка (кому/зачем)" fullWidth />
        <NumberInput source="ttl_days" label="Срок действия, дней" min={1} />
      </SimpleForm>
    </Create>
  );
}
